<template>
  <v-row no-gutters style="background-color: white" id="products">
    <v-col cols="12">
      <v-row no-gutters class="prod-row" style="background-color: white">
        <v-col cols="12" xl="6" lg="6" sm="12">
          <v-row class="pa-4" :class="!$vuetify.breakpoint.mdAndDown ? '' : 'pl-0'">
            <v-col
              cols="12"
              xl="6"
              lg="6"
              sm="12"
              v-for="(item, index) in products_fr"
              :key="index"
            >
              <v-card class="prod-card mt-6 pa-5" flat :class="!$vuetify.breakpoint.mdAndDown ? '' : 'pl-0'">
                <v-icon
                  
                  :class="!$vuetify.breakpoint.mdAndDown ? 'pl-4' : 'pl-5'"
                  color="#a81e2d"
                  v-text="item.icon"
                ></v-icon>
                <v-card-title> {{ item.title }}</v-card-title>
                <v-card-text style="min-height: 110px !important">
                  {{ item.desc }}
                </v-card-text>
              </v-card>

              <v-divider
                v-if="index < 2 || $vuetify.breakpoint.mdAndDown"
                color="#a81e2d"
                inset
                class="prod-card" :class="!$vuetify.breakpoint.mdAndDown ? ' ml-9' : ' ml-3'"
                style="padding: 1px !important; border: none !important"
              ></v-divider>
            </v-col>
          </v-row>
        </v-col>
        <v-col
          justify="center"
          align="center"
          cols="12"
          xl="6"
          lg="6"
          sm="12"
          class="order-first"
        >
          <v-img
            class="prod-img mt-10"
            :src="require('@/assets/imgs/' + 'ProgrammerAnalyst.jpg')"
            contain
          >
          </v-img>
        </v-col>
      </v-row>

      <v-row no-gutters class="prod-row" style="background-color: white">
        <v-col cols="12" xl="6" lg="6" sm="12">
          <div class="und-hdr font-italic  pt-16" :class="!$vuetify.breakpoint.mdAndDown ? 'pl-14' : 'pl-4'">
            Complete Business <br />Solutions
          </div>

          <v-divider
            color="#a81e2d"
            width="50px"
            class="my-2" :class="!$vuetify.breakpoint.mdAndDown ? 'ml-14' : 'ml-4'"
            style="padding: 1px !important; border: none !important"
          ></v-divider>
          <div class="pt-3" :class="!$vuetify.breakpoint.mdAndDown ? 'pl-14' : 'pl-4'">
            3545 Consulting® works with you to make technology work for you.<br/> Do
            you know all that we do?
          </div>
          <v-row class="pa-4" :class="!$vuetify.breakpoint.mdAndDown ? '' : 'pl-0'">
            <v-col
              cols="12"
              xl="6"
              lg="6"
              sm="12"
              v-for="(item, index) in products_sc"
              :key="index"
            >
              <v-card class="prod-card pr-5 pb-5" flat :class="!$vuetify.breakpoint.mdAndDown ? 'pl-5' : ''">
                <v-card-title> {{ item.title }}</v-card-title>
                <v-card-text style="min-height: 80px !important">
                  {{ item.desc }}
                </v-card-text>
              </v-card>

              <v-divider
                v-if="index < 2 || $vuetify.breakpoint.smAndDown && index < 3"
                color="#a81e2d"
                inset
                class="prod-card "
                :class="!$vuetify.breakpoint.mdAndDown ? 'ml-9' : 'ml-4'"
                style="padding: 1px !important; border: none !important"
              ></v-divider>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12"  xl="6" lg="6" sm="12">
          <v-img
            class="prod-img"
            :src="require('@/assets/imgs/' + 'mental.jpg')"
            min-height="650px"
            
          >
          </v-img>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<style lang="scss" scoped>
.und-hdr {
  font-weight: 1000 !important;
  font-size: 36px;
  font-family: Raleway;
}
</style>

<script>
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger.js";
gsap.registerPlugin(ScrollTrigger);

export default {
  name: "SolutionsSec",
  data() {
    return {
      products_sc: [
        {
          title: "Consulting",
          desc: "Our goal is to help you make the best out of your software for your practice.",
        },
        {
          title: "Training",
          desc: "We focus on training you in the use of software and best practices to maximize ROI.",
        },
        {
          title: "Leave Billing To Us",
          desc: "We’ll train and help you establish best practices for successful billing, improving your accounting workflow, or you can leave the billing and bookkeeping to us.",
        },
        {
          title: "Product Selection",
          desc: "We know everyone doesn’t know what software works best for their practice but we do! We have numerous certified consultants that can get you pointed in the right direction.",
        },
      ],
      products_fr: [
        {
          icon: "fas fa-user-tie",
          title: "Consulting",
          desc: "We’ll work with you from start to finish on getting set up on a new software or help you optimize the best out of your current software.",
        },
        {
          icon: "fas fa-cloud",
          title: "Networks & Cloud",
          desc: "Hosting your data is important and knowing how to host it is even more important.",
        },
        {
          icon: "fas fa-chart-pie",
          title: "Business Pulse Analytics",
          desc: "Data is meaningless if you don’t understand it. We help put this into context for you to better optimize your business.",
        },
        {
          icon: "fas fa-phone-volume",
          title: "Friendly Support",
          desc: "We make sure your needs are taken care of and always try to find the right solution for you.",
        },
      ],
    };
  },
  mounted() {
    gsap.utils.toArray(".prod-card").forEach((item) => {
      gsap.from(item, {
        scrollTrigger: {
          trigger: item,
        },
        opacity: 0,
        x: -500,
        duration: 1,
        stagger: 0.1,
      });
    });

    gsap.utils.toArray(".prod-img").forEach((item) => {
      gsap.from(item, {
        scrollTrigger: {
          trigger: item,
        },
        opacity: 0,
        x: 500,
        duration: 1,
        stagger: 0.1,
      });
    });
  },
};
</script>